<template>
  <section :class="sectionClasses" :style="sectionStyles">
    <v-container :class="containerClass">
      <slot></slot>
    </v-container>
  </section>
</template>

<script>
export default {
  name: 'SectionWrapper',
  props: {
    background: {
      type: String,
      default: 'white',
      validator: (value) => [
        'white',
        'light',
        'dark',
        'gradient-purple',
        'gradient-blue',
        'gradient-dark',
        'custom'
      ].includes(value)
    },
    customBackground: {
      type: String,
      default: null
    },
    padding: {
      type: String,
      default: 'default',
      validator: (value) => ['small', 'default', 'large', 'none'].includes(value)
    },
    containerClass: {
      type: String,
      default: ''
    }
  },
  computed: {
    sectionClasses() {
      return [
        'section-wrapper',
        `section-wrapper--bg-${this.background}`,
        `section-wrapper--padding-${this.padding}`
      ]
    },
    sectionStyles() {
      if (this.background === 'custom' && this.customBackground) {
        return { background: this.customBackground }
      }
      return {}
    }
  }
}
</script>

<style scoped>
.section-wrapper {
  position: relative;
  width: 100%;
}

/* Background Variants */
.section-wrapper--bg-white {
  background-color: #ffffff;
}

.section-wrapper--bg-light {
  background-color: #f5f5f5;
}

.section-wrapper--bg-dark {
  background-color: #1a1a2e;
  color: white;
}

.section-wrapper--bg-gradient-purple {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
}

.section-wrapper--bg-gradient-blue {
  background: linear-gradient(135deg, #141E30 0%, #243B55 100%);
  color: white;
}

.section-wrapper--bg-gradient-dark {
  background: linear-gradient(135deg, #0f0c29 0%, #302b63 50%, #24243e 100%);
  color: white;
}

/* Padding Variants */
.section-wrapper--padding-none {
  padding: 0;
}

.section-wrapper--padding-small {
  padding: 60px 0;
}

.section-wrapper--padding-default {
  padding: 80px 0;
}

.section-wrapper--padding-large {
  padding: 100px 0;
}

/* Responsive Padding */
@media (max-width: 960px) {
  .section-wrapper--padding-small {
    padding: 45px 0;
  }

  .section-wrapper--padding-default {
    padding: 60px 0;
  }

  .section-wrapper--padding-large {
    padding: 75px 0;
  }
}

@media (max-width: 600px) {
  .section-wrapper--padding-small {
    padding: 35px 0;
  }

  .section-wrapper--padding-default {
    padding: 45px 0;
  }

  .section-wrapper--padding-large {
    padding: 55px 0;
  }
}

@media (max-width: 400px) {
  .section-wrapper--padding-small {
    padding: 30px 0;
  }

  .section-wrapper--padding-default {
    padding: 40px 0;
  }

  .section-wrapper--padding-large {
    padding: 50px 0;
  }
}
</style>
